import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.match";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// Utility function to get TRBL shorthand declaration for paddings and margins.
export var getShorthand = function getShorthand(property, unit) {
  var _property = _slicedToArray(property, 4),
      t = _property[0],
      r = _property[1],
      b = _property[2],
      l = _property[3];

  if (property.length === 3) {
    // Not all sides are defined, vertical borders are the same
    l = r;
  } else if (property.length === 2) {
    // Vertical and horizontal borders are the same
    l = r;
    b = t;
  } else if (property.length === 1) {
    // All borders are the same
    r = t;
    b = t;
    l = t;
  }

  if (!unit) return [t, r, b, l];
  return "".concat(t).concat(unit, " ").concat(r).concat(unit, " ").concat(b).concat(unit, " ").concat(l).concat(unit);
}; // Function to consistently allow adding margins, borders and padding, without breaking vertical rhythm.

export var getBoxModel = function getBoxModel(padding, border, margin) {
  var style = [];
  var subtractTop = 0,
      subtractBottom = 0;

  if (border) {
    // Get borders from border argument (which is an array)
    // Follows the top, right, bottom, left css shorthand convention
    var _getShorthand = getShorthand(border),
        _getShorthand2 = _slicedToArray(_getShorthand, 4),
        t = _getShorthand2[0],
        r = _getShorthand2[1],
        b = _getShorthand2[2],
        l = _getShorthand2[3];

    style.push("border-top: ".concat(t, "; border-right: ").concat(r, "; border-bottom: ").concat(b, "; border-left: ").concat(l, ";")); // Calculate the amount of pixels to subtract from the margin, to adjust for borders.

    subtractTop = (parseInt(t.split(" ")[0].match(/-?\d+\.?\d*/)[0]) / 10).toFixed(2);
    subtractBottom = (parseInt(b.split(" ")[0].match(/-?\d+\.?\d*/)[0]) / 10).toFixed(2);
  }

  if (margin) {
    var _getShorthand3 = getShorthand(margin),
        _getShorthand4 = _slicedToArray(_getShorthand3, 4),
        mT = _getShorthand4[0],
        mR = _getShorthand4[1],
        mB = _getShorthand4[2],
        mL = _getShorthand4[3]; // Same as border


    style.push("margin: ".concat(mT - subtractTop, "rem ").concat(mR, "rem ").concat(mB - subtractBottom, "rem ").concat(mL, "rem;"));
  }

  if (padding) {
    // Same as border
    var _getShorthand5 = getShorthand(padding),
        _getShorthand6 = _slicedToArray(_getShorthand5, 4),
        pT = _getShorthand6[0],
        pR = _getShorthand6[1],
        pB = _getShorthand6[2],
        pL = _getShorthand6[3];

    style.push("padding: ".concat(pT, "rem ").concat(pR, "rem ").concat(pB, "rem ").concat(pL, "rem;"));
  }

  return style.join("");
};